import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ChevronLeftIcon from '@/assets/icons/chevron-left.svg';
import { Button, ButtonVariant } from '@/components/form/button';

interface IProps {
  onBack?: () => void;

  /** JSX|String component */
  children?: React.ReactNode | string;
}

/**
 * TopBar will be float as a sticky utility menu
 */
export const TopBar: React.FC<IProps> = ({ onBack, children }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // if on back defined, invoke. Else go back to previous route
  const onBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="flex items-center top-[62px] md:top-[94px] z-30 fixed left-0 right-0 w-full pt-6 bg-white container mx-auto px-4">
      <div className="flex rounded-lg md:container md:mx-auto bg-[#FAFAFA] items-center h-8 w-full px-4 justify-between">
        <Button
          variant={ButtonVariant.Link}
          classnames="flex items-center gap-1"
          onClick={onBackClick}
        >
          <img src={ChevronLeftIcon} alt="back" />
          <span className="text-sm">{t('common.back')}</span>
        </Button>

        <div>{children}</div>
      </div>
    </div>
  );
};
